import { useEffect } from 'react'
import { isStandalone, setHead, useInstall } from '../admin/pwa'
import { usePublic } from './context'

/** Site d'origine de l'application installée (retour après déconnexion de la gestion). */
export const APP_SITE = 'publiqa-app-site'

const iconUrl = (slug: string, size: number) => `/api/v1/public/p/${slug}/app-icon-${size}.png`

/**
 * Le site comme application de téléphone : une fois ajouté à l'écran
 * d'accueil, il s'ouvre en plein écran, sans barre d'adresse, et la
 * connexion à l'espace de gestion reste dans l'application.
 */
export function useSiteApp() {
  const { publication, base, preview } = usePublic()
  const { slug, name } = publication
  const theme = publication.settings.theme
  useEffect(() => {
    if (preview) return
    const home = base === '' ? '/' : `/p/${slug}`
    setHead('link', {
      rel: 'manifest',
      href: `/api/v1/public/p/${slug}/app.webmanifest${base === '' ? '?root=1' : ''}`,
    })
    setHead('link', { rel: 'apple-touch-icon', href: iconUrl(slug, 180) })
    setHead('meta', {
      name: 'theme-color',
      content: theme.header === 'primary' ? theme.primary : '#ffffff',
    })
    setHead('meta', { name: 'mobile-web-app-capable', content: 'yes' })
    setHead('meta', { name: 'apple-mobile-web-app-capable', content: 'yes' })
    setHead('meta', { name: 'apple-mobile-web-app-title', content: name })
    setHead('meta', { name: 'apple-mobile-web-app-status-bar-style', content: 'default' })
    if ('serviceWorker' in navigator && location.protocol === 'https:')
      navigator.serviceWorker.register('/sw.js', { scope: '/' }).catch(() => undefined)
    if (isStandalone())
      try {
        sessionStorage.setItem(APP_SITE, home)
      } catch {
        /* stockage indisponible */
      }
  }, [slug, name, base, preview, theme.header, theme.primary])
}

/** Bandeau « Installer l'application » du site, sur téléphone. */
export function SiteInstall() {
  const { publication, preview, inert } = usePublic()
  const { show, direct, install, close } = useInstall(`publiqa-site-install-${publication.slug}`)
  if (!show || preview || inert) return null
  return (
    <div className="site-install" role="note">
      <img src={iconUrl(publication.slug, 192)} alt="" width="44" height="44" />
      <p>
        <strong>L’application {publication.name}</strong>
        {direct ? (
          <span>Sur votre écran d’accueil, en plein écran.</span>
        ) : (
          <span>
            Touchez <b>Partager</b> puis <b>« Sur l’écran d’accueil »</b>.
          </span>
        )}
      </p>
      {direct && (
        <button type="button" className="btn btn-primary" onClick={install}>
          Installer
        </button>
      )}
      <button type="button" className="site-install-close" aria-label="Plus tard" onClick={close}>
        ✕
      </button>
    </div>
  )
}
